import React from 'react';
import {Outlet} from 'react-router-dom';
import Analytics from '../component/analytics/Analytics';
import AiAgent from '../component/aiAgent/AiAgent';
import useIsAiAgentFabRendered from '../hooks/useIsAiAgentFabRendered';

const RootLayout = () => {
    const isAiAgentRendered = useIsAiAgentFabRendered();

    return (
        <>
            <Analytics />
            <Outlet />
            {isAiAgentRendered && <AiAgent />}
        </>
    );
};

export default RootLayout;
